export default __webpack_public_path__ + "static/media/txt_apply.f77976a6.svg";